module.exports = __webpack_public_path__ + "static/media/15.49d5c03d.jpg";